import { UppKonvaShape } from '../upp-konva-shape';
import type { UppKonvaGenericShapeOptions } from '../upp-konva-options';

/** Generic furniture shape. */
export class UppKonvaGenericShape extends UppKonvaShape {
    // 1. Type contract
    readonly kind = 'GENERIC' as const;

    // 2. Lifecycle
    constructor(opts: UppKonvaGenericShapeOptions) {
        const { shape, ...rest } = opts;
        super({ ...rest, data: { shape } });
    }
}
